import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { POST } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// Send Contact Us form
export const CreateContact_Us = createAsyncThunk(
  "/website/contact-us/call_contact_us",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.ContactUs.call_contact_us, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "call_contact_us",
  initialState: {
    data: null,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {
    resetContactState: (state) => {
      state.data = null;
      state.status = IDS.SLICESTATUS.Idle;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(CreateContact_Us.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateContact_Us.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload.data;
      })
      .addCase(CreateContact_Us.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export const { resetContactState } = Slice.actions;
export default Slice.reducer;
